/**
 * @generated SignedSource<<d210d0d87516867daec73a556fa7cdf4>>
 * @relayHash ab83aaccd05a494b1cf107c911ddd413
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c03225dbb59142b70bdc77143f6748d54be578263c61b66a60c5aad99af922fc

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useFetchConnectedProjectsProjectHasRelatedWorkWithProjectQuery$variables = {
  id: string;
};
export type useFetchConnectedProjectsProjectHasRelatedWorkWithProjectQuery$data = {
  readonly graphStore: {
    readonly projectHasRelatedWorkWithProject: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly avatar?: {
            readonly small: string | null | undefined;
          } | null | undefined;
          readonly name?: string;
          readonly projectId?: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useFetchConnectedProjectsProjectHasRelatedWorkWithProjectQuery = {
  response: useFetchConnectedProjectsProjectHasRelatedWorkWithProjectQuery$data;
  variables: useFetchConnectedProjectsProjectHasRelatedWorkWithProjectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "small"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useFetchConnectedProjectsProjectHasRelatedWorkWithProjectQuery",
    "selections": [
      {
        "concreteType": "GraphStore",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "GraphStoreSimplifiedProjectHasRelatedWorkWithProjectConnection",
            "kind": "LinkedField",
            "name": "projectHasRelatedWorkWithProject",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedProjectHasRelatedWorkWithProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "RequiredField",
                            "field": (v3/*: any*/),
                            "action": "THROW",
                            "path": "graphStore.projectHasRelatedWorkWithProject.edges.node.name"
                          },
                          (v4/*: any*/)
                        ],
                        "type": "JiraProject"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useFetchConnectedProjectsProjectHasRelatedWorkWithProjectQuery",
    "selections": [
      {
        "concreteType": "GraphStore",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "GraphStoreSimplifiedProjectHasRelatedWorkWithProjectConnection",
            "kind": "LinkedField",
            "name": "projectHasRelatedWorkWithProject",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedProjectHasRelatedWorkWithProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ],
                        "type": "JiraProject"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  },
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c03225dbb59142b70bdc77143f6748d54be578263c61b66a60c5aad99af922fc",
    "metadata": {},
    "name": "useFetchConnectedProjectsProjectHasRelatedWorkWithProjectQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a4e9cf70c3f9e4d374cbdbe2a5320ea0";

export default node;
